import request from '@/utils/request'

let PointProductApi = {
    /*商品列表*/
    productList(data) {
        return request._post('/shop/plus.points.product/index', data);
    },
    /*添加商品*/
    addProduct(data) {
        return request._post('/shop/plus.points.product/add', data);
    },
    /*获取详情*/
    getProduct(data) {
        return request._get('/shop/plus.points.product/add', data);
    },
    /*获取积分商品*/
    getPointProduct(data) {
        return request._get('/shop/plus.points.product/edit', data);
    },
    /*编辑积分商品*/
    editPointProduct(data) {
        return request._post('/shop/plus.points.product/edit', data);
    },
    /*删除商品*/
    deleteProduct(data) {
        return request._post('/shop/plus.points.product/delete', data);
    },
    /*保存配置*/
    saveConfig(data) {
        return request._post('/shop/plus.points.product/settings', data);
    },
    /*保存配置*/
    getConfig(data) {
        return request._get('/shop/plus.points.product/settings', data);
    },
    /*获取兑换记录*/
    getExchange(data) {
        return request._post('/shop/plus.points.product/record', data);
    },

}
export default PointProductApi;



// WEBPACK FOOTER //
// ./src/api/pointproduct.js